__turbopack_context__.v({
  "container": "UmXD-G_container",
  "content": "UmXD-G_content",
  "copyButton": "UmXD-G_copyButton",
  "footer": "UmXD-G_footer",
  "linkDetailsHeader": "UmXD-G_linkDetailsHeader",
  "sharedLink": "UmXD-G_sharedLink",
  "sharedLinkDetails": "UmXD-G_sharedLinkDetails",
  "sharedLinkNote": "UmXD-G_sharedLinkNote",
});
